<template>
  <ComingSoonFeatureVote
    
    :title="$t('broker.app.navigation.quests')"
    :description="$t('broker.quests.questsDescription')"
    :image-src="imageSrc"
    feature-name="COMING_FEATURE_QUEST"
  />
</template>

<script>
import ComingSoonFeatureVote from "../components/ComingSoonFeatureVote.vue";

export default {
  name: "QuestsView",
  components: {
    ComingSoonFeatureVote,
  },
  data() {
    return {
      imageSrc: require("../assets/Image-Quests.png"),
    };
  },
};
</script>
